import { createWrappedFetch } from './wrappedFetch';
import { getCoreServiceContext, includeCredentials } from './middleware/core';
import { logoutOn401, logoutOnMissingPortalId } from './middleware/logout';
import {
  redirectOnMigrationInProgress,
  redirectOnPortalMoved,
} from './middleware/redirects';
import { setStandardHeaders } from './middleware/headers';
import { addPortalIdQueryParam } from './middleware/portalId';
import { addHostPure } from './middleware/addHostPure';
import { ChirpGateway, Environment, LoadBalancer } from './types';
import { chirpGateways } from './constants';

interface ChirpFetchConfiguration {
  // TODO: Figure out the correct matrix of LB + GW combos and make this an enum?
  loadBalancer: LoadBalancer;
  gateway: ChirpGateway;
  env?: Environment; // Not importing this from standard library to reduce a dependency
  // Intended ONLY FOR API-Goggles which has correctly set values.
  hublet?: string; // Not importing this from standard library to reduce a dependency

  useLongLivedLb?: boolean;
}

export const createChirpFetch = ({
  loadBalancer,
  gateway,
  env,
  hublet,
  useLongLivedLb,
}: ChirpFetchConfiguration) => {
  const isExternalGateway = gateway === chirpGateways.EXTERNAL;
  const baseConfiguration = {
    context: { gateway, loadBalancer, env, hublet, useLongLivedLb },
    requestContext: [getCoreServiceContext],
    middleware: [
      addHostPure, // Must run first to ensure all URLs are absolute
      includeCredentials,
      setStandardHeaders,
      // Only check portal ID for APP load balancer, not EXTERNAL
      ...(isExternalGateway ? [] : [logoutOnMissingPortalId]),
      addPortalIdQueryParam,
    ],
    onResponse: [
      // Don't logout on 401 for external APIs
      ...(isExternalGateway
        ? []
        : [logoutOn401, redirectOnMigrationInProgress, redirectOnPortalMoved]),
    ],
    onResponseError: [],
  };

  return createWrappedFetch(baseConfiguration);
};

export function createChirpFetchConfig({
  loadBalancer,
  gateway,
  env,
  hublet,
  useLongLivedLb,
}: ChirpFetchConfiguration) {
  return {
    loadBalancer,
    gateway,
    env,
    hublet,
    useLongLivedLb,
  };
}
